import { accessToken } from '../auth/supabase.js'
import { config } from '../config.js'

export class GatewayError extends Error {
  constructor(code, status, detail) {
    super(code || `gateway_${status}`)
    this.name = 'GatewayError'
    this.code = code || 'gateway_error'
    this.status = status
    this.detail = detail
  }
}

export async function gatewayRequest(path, options = {}) {
  const token = await accessToken()
  if (!token) throw new GatewayError('not_signed_in', 401)
  const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` }
  if (options.body != null && !headers['Content-Type'] && typeof options.body === 'string') headers['Content-Type'] = 'application/json'
  const response = await fetch(`${config.apiBaseUrl}${path}`, { ...options, headers })
  if (!response.ok) {
    let detail = null
    try { detail = await response.json() } catch {}
    throw new GatewayError(detail?.error || `http_${response.status}`, response.status, detail)
  }
  if (response.status === 204) return null
  return response.json()
}
